<template>
  <div>
    <div class="pure-g">
      <div class="pure-u-1">
        <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
          <fieldset>
            <div :ref="mountPointRefName">
            </div>
            <div v-if="isStripeLoading">
              <div class="centered-row">
                <div class="loading">
                  <Fai :icon="['far', 'circle-notch']" spin/>
                </div>
              </div>
            </div>
            <button type="submit" class="hidden-submit"></button>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {loggerMixin} from '../../mixins/logger'
  import {
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
  } from '../../services/constants'

  export default {
    name: 'Payment',
    mixins: [loggerMixin],
    data() {
      return {
        wasMounted: false,
        cardRef: null,
      }
    },
    watch: {
      'stripeLoadingState': function () {
        this.onMountedOrStripeLoadingStateChange()
      },
    },
    computed: {
      ...mapGetters([]),
      stripeLoadingState() {
        return this.$store.state.paymentModule.scriptTag.loadingState
      },
      isStripeLoading() {
        return this.stripeLoadingState === LOADING_STARTED
      },
      stripeInstance() {
        return this.$store.state.paymentModule.stripeObj
      },
      mountPointRefName() {
        return 'stripe-mount'
      },
      injectedStyle() {
        return {
          base: {
            color: '#314a59',
            fontFamily: 'Questrial, sans-serif',
            fontSize: '16px',
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      }
    },
    methods: {
      handleSubmit() {
        this.log('handleSubmit mock')
      },
      onMountedOrStripeLoadingStateChange() {
        if (this.wasMounted) {
          this.possiblyMountStripeCard()
        }
      },
      possiblyMountStripeCard() {
        if (this.stripeLoadingState === LOADING_COMPLETED_SUCCESS) {
          this.mountStripeCard()
        }
      },
      mountStripeCard() {
        this.cardRef = this.stripeInstance.elements().create('card', {style: this.injectedStyle})
        this.cardRef.mount(this.$refs[this.mountPointRefName])
      }
    },
    mounted() {
      this.wasMounted = true
      this.onMountedOrStripeLoadingStateChange()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .loading {
    color: $red-2;
  }

</style>
